<template>
  <v-card>
    <v-toolbar
      class="px-4"
      style="background: linear-gradient(60deg,#66bb6a,#43a047); color: white;"
    >
      <span
        style="font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;"
        >{{
          [$t('commonWords.edit'), $t('intentsList.examples')].join(' ')
        }}</span
      >
      <v-spacer></v-spacer>
      <md-button @click.stop="$emit('close')" class="md-simple md-just-icon">
        <md-icon>close</md-icon>
      </md-button>
    </v-toolbar>
    <v-card-text class="pa-0">
      <md-card-content>
        <v-row
          no-gutters
          class="pa-0"
          style="margin-top: 20px; margin-bottom: 20px; width: 100%;"
        >
          <md-field style="margin-top: 0;">
            <md-input
              v-model="example"
              @click.stop
              :placeholder="$t('editIntentExample.thisExampleIsAlreadyRegisteredInThisIntent')"
              @keyup.enter="save"
            ></md-input>
          </md-field>
        </v-row>
      </md-card-content>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <md-button
        @click.stop="$emit('close')"
        class="md-danger"
        style="margin-right: 8px;"
      >
        <span>{{ $t('commonWords.cancel') }}</span>
      </md-button>
      <md-button @click.stop="save" class="md-success">
        <span>{{ $t('commonWords.save') }}</span>
      </md-button>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    value: String
  },
  data: () => ({
    example: ''
  }),
  watch: {
    value () {
      this.example = this.value
    }
  },
  methods: {
    save () {
      this.$emit('update:value', this.example)
      this.$emit('close')
    }
  },
  mounted () {
    this.example = this.value
  }
}
</script>

<style>
</style>
